// extracted by mini-css-extract-plugin
module.exports = {"color-white":"#FFFFFF","colorWhite":"#FFFFFF","designerSection":"vo_nx","designerTitle":"_2S3sg"};